export default class Config {
    public static apiHost = "http://localhost:8080";
    public static username = '';
    public static token = '';
}